package com.hyperether.goodjob.scenes.register

import androidx.compose.runtime.Composable

@Composable
expect fun PlatformLogin(
    emailLabel: String,
    emailPlaceholder: String,
    passwordLabel: String,
    passwordPlaceholder: String,
    forgotPasswordLabel: String,
    loginButtonLabel: String,
    onCredentialsEntered: (email: String, password: String) -> Unit,
    onPasswordForgotten: (email: String) -> Unit,
    visibility: Boolean = true,
    onCreateAccount: () -> Unit = {}
)

private val emailRegex = Regex("^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$")

fun isValidEmail(email: String): Boolean {
    return email.matches(emailRegex)
}
